<template>
	<div class="login">
		<v-card class="rounded-lg login-card">
			<h2>Login</h2>
			<v-form v-model="valid">
				<!-- Email text field -->
				<v-text-field
					v-model="email"
					label="Email"
					required
					:rules="emailValidator"
					type="email"
				></v-text-field>

				<!-- Password text field -->
				<!-- Logic to show/hide password after label -->
				<v-text-field
					v-model="password"
					label="Contraseña"
					:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
					@click:append="showPassword = !showPassword"
					:type="showPassword ? 'text' : 'password'"
					@keyup.enter="login"
					:rules="passwordValidator"
				>
				</v-text-field>

				<v-card-actions class="card-actions">
					<!-- Login button -->
					<v-btn
						color="accent"
						@click="login"
						:disabled="!valid"
						class="rounded-lg"
						block
						elevation="0"
					>
						Login
					</v-btn>
				</v-card-actions>

				<!-- End of form -->
			</v-form>
		</v-card>
	</div>
</template>

<script>
	import axios from "axios";
	import validator from "validator";
	export default {
		name: "Login",
		data: () => ({
			valid: false,
			email: "",
			password: "",
			showPassword: false,
			emailValidator: [(v) => validator.isEmail(v) || "Email inválido"],
			passwordValidator: [
				(v) => v !== "" || "La contraseña no debe estar vacía",
			],
		}),
		methods: {
			/**
			 * Logs in the user
			 */
			async login() {
				try {
					//Wait for the response
					const response = await axios.post("/admin/login", {
						email: this.email,
						password: this.password,
					});

					//And then save token to store and localstorage through the store action
					this.$store.dispatch("admin/authSuccess", response.data.token);

					//Then redirect to the main admin page
					this.$router.push({ name: "AdminStats" });
				} catch (error) {
					//In case the credentials are wrong, send a message to the user
					if (error.response && error.response.status === 400) {
						this.$emit("snackbar-event", {
							color: "error",
							text: "Credenciales Incorrectas",
						});
					} else if (error.response && error.response.status === 500) {
						//Show error snackbar
						this.$emit("snackbar-event", {
							color: "error",
							text:
								"Ha ocurrido un error, vuelva a intentarlo más tarde",
						});
					}
				}
			},
		},
		mounted() {
			this.$emit("loading", false);
		},
	};
</script>

<style lang="scss" scoped>
	@import "../../scss/_mixins.scss";
	@import "../../scss/_variables.scss";
	.login {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		background-color: #f0f0f3;

		.login-card {
			padding: 2em;
			width: 100%;
			max-width: 400px;
			height: fit-content;

			h2 {
				margin-bottom: 0.5em;
			}

			.card-actions {
				margin-top: 1.5em;
				padding: 0;
			}

			.new-account {
				margin-top: 1em;

				a {
					color: $accent;
				}
			}
		}
	}
</style>
